import React from "react";
import { Spinner } from 'takeat-design-system-ui-kit';

const TableComponent = ({
    
  filters,
  handleFilterChange,
  handleTableFilterChange,
  processedRequests,
  filteredRestaurants,
  handleDownload,
  formatarData
}) => {
  return (
    <div style={{ maxWidth: "100vw" }}>
      {/* 🔹 Filtros */}
      <div className="general_selects">
        <label>
          <input
            type="checkbox"
            name="only_not_deleted"
            checked={filters.only_not_deleted}
            onChange={handleFilterChange}
            disabled={processedRequests < 5}
          />
          Somente lojas não deletadas
        </label>

        <label>
          <input
            type="checkbox"
            name="is_inactive"
            checked={filters.is_inactive}
            onChange={handleFilterChange}
            disabled={processedRequests < 5}
          />
          Excluir lojas sem faturamento
        </label>

        <label>
          <input
            type="checkbox"
            name="fat_0_30"
            checked={filters.fat_0_30}
            onChange={handleFilterChange}
            disabled={processedRequests < 5}
          />
          Restaurantes com baixo faturamento (30d)
        </label>

        <label>
          <input
            type="checkbox"
            name="only_club_stores"
            checked={filters.only_club_stores}
            onChange={handleFilterChange}
            disabled={processedRequests < 5}
          />
          Somente lojas com clientes pontuados no clube
        </label>
      </div>

      {/* 🔹 Cabeçalho da Tabela */}
      <div className="table-wrapper">
        <div className="table-header">
          <h2 className="mean-sized-title">Parceiros - {filteredRestaurants.length} </h2>
          <div style={{ display: "flex", gap: 10 }}>
            {processedRequests < 5 && <Spinner size={22} />}
            <button
              className="download-btn"
              onClick={handleDownload}
              disabled={processedRequests < 5}
            >
              📥 Baixar Excel
            </button>
          </div>
        </div>

        {/* 🔹 Tabela */}
        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>
                  <input
                    type="text"
                    placeholder="Username"
                    value={filters.name}
                    onChange={(e) => handleTableFilterChange(e, "name")}
                  />
                </th>
                <th>MRR</th>
                <th>
                  <input
                    type="text"
                    placeholder="Cidade"
                    value={filters.city}
                    onChange={(e) => handleTableFilterChange(e, "city")}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    placeholder="UF"
                    value={filters.state}
                    onChange={(e) => handleTableFilterChange(e, "state")}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    placeholder="Email"
                    value={filters.email}
                    onChange={(e) => handleTableFilterChange(e, "email")}
                  />
                </th>
                <th>WhatsApp Dono</th>
                <th>
                  <input
                    type="text"
                    placeholder="Plano"
                    value={filters.plano}
                    onChange={(e) => handleTableFilterChange(e, "plano")}
                  />
                </th>
                <th>Faturamento 0-30d</th>
                <th>Faturamento 30-60d</th>
                <th>Faturamento 60-90d</th>
                <th>Últ. Comanda em 90d</th>
                <th># Comandas (90d)</th>
                <th># Comandas Fechadas</th>
                <th>Tem Fiscal?</th>
                <th># Notas Emitidas</th>
                <th>Tem Clube?</th>
                <th># Clientes Pontuados</th>
                <th># Resgates</th>
              </tr>
            </thead>
            <tbody>
              {filteredRestaurants.map((item, index) => (
                <tr key={index}>
                  <td>{item.name || "-"}</td>
                  <td>
                    {typeof item.mrr === "number"
                      ? `R$ ${item.mrr.toFixed(2)}`
                      : "-"}
                  </td>
                  <td>{item.city || "-"}</td>
                  <td>{item.state || "-"}</td>
                  <td>{item.email || "-"}</td>
                  <td>{item.owner_wpp || "-"}</td>
                  <td>{item.plano || "-"}</td>
                  <td>
                    {typeof item.faturamento_30_0 === "number"
                      ? `R$ ${item.faturamento_30_0.toFixed(2)}`
                      : "-"}
                  </td>
                  <td>
                    {typeof item.faturamento_60_30 === "number"
                      ? `R$ ${item.faturamento_60_30.toFixed(2)}`
                      : "-"}
                  </td>
                  <td>
                    {typeof item.faturamento_90_60 === "number"
                      ? `R$ ${item.faturamento_90_60.toFixed(2)}`
                      : "-"}
                  </td>
                  <td>
                    {item.last_created_at !== null
                      ? formatarData(item.last_created_at)
                      : "-"}
                  </td>
                  <td>{item.comandas || "-"}</td>
                  <td>{item.comandas_fechadas || "-"}</td>
                  <td>{item.fiscal ? "SIM" : "NÃO"}</td>
                  <td>{item.total_nfces || "-"}</td>
                  <td>{item.token ? "SIM" : "NÃO"}</td>
                  <td>{item.clients || "-"}</td>
                  <td>{item.rescues || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TableComponent;
